var _metadata, _defs, _clipPath, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordComponent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg111",
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    stroke: "none",
    fill: "none",
    viewBox: "0.0 0.0 348.0 348.0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata117"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs115"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    clipRule: "nonzero",
    d: "m0 0l348.0 0l0 348.0l-348.0 0l0 -348.0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g85",
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5",
    fillRule: "evenodd",
    d: "M 0,0 H 348 V 348 H 0 Z",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7",
    fillRule: "evenodd",
    d: "M -6,0 H 348.01575 V 347.9685 H -6 Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    fillRule: "evenodd",
    d: "m 5.07874,5.7758217 h 336.9134 V 343.4451 H 5.07874 Z",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    fillRule: "evenodd",
    d: "m 5.07874,5.7758217 h 336.9134 V 343.4451 H 5.07874 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    fillRule: "evenodd",
    d: "m 282.73444,40.553925 v 0 c 0,-8.375591 6.96603,-15.165352 15.55905,-15.165352 v 0 c 4.12653,0 8.08402,1.597773 11.00192,4.441828 2.91788,2.844057 4.55713,6.701422 4.55713,10.723524 v 0 c 0,8.375595 -6.966,15.165356 -15.55905,15.165356 v 0 c -8.59302,0 -15.55905,-6.789761 -15.55905,-15.165356 z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    fillRule: "evenodd",
    d: "m 282.73444,40.553925 v 0 c 0,-8.375591 6.96603,-15.165352 15.55905,-15.165352 v 0 c 4.12653,0 8.08402,1.597773 11.00192,4.441828 2.91788,2.844057 4.55713,6.701422 4.55713,10.723524 v 0 c 0,8.375595 -6.966,15.165356 -15.55905,15.165356 v 0 c -8.59302,0 -15.55905,-6.789761 -15.55905,-15.165356 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    fillRule: "evenodd",
    d: "M 50.949955,90.04964 60.41452,72.726802 69.879089,90.04964 Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19",
    fillRule: "evenodd",
    d: "M 50.949955,90.04964 60.41452,72.726802 69.879089,90.04964 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21",
    fillRule: "evenodd",
    d: "m 122.04724,268.00525 h 97.92126 v 41.88977 h -97.92126 z",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23",
    fillRule: "evenodd",
    d: "m 122.04724,268.00525 h 97.92126 v 41.88977 h -97.92126 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path25",
    fillRule: "evenodd",
    d: "M 29.517061,106.30446 H 289.61154 v 96.81889 H 29.517061 Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27",
    fillRule: "evenodd",
    d: "M 29.517061,106.30446 H 289.61154 v 96.81889 H 29.517061 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path29",
    fillRule: "evenodd",
    d: "m 35.627296,113.07874 h 49.574806 v 82.14173 H 35.627296 Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path31",
    fillRule: "evenodd",
    d: "m 35.627296,113.07874 h 49.574806 v 82.14173 H 35.627296 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 1,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33",
    fillRule: "evenodd",
    d: "m 85.2021,113.07874 h 49.5748 v 82.14173 H 85.2021 Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path35",
    fillRule: "evenodd",
    d: "m 85.2021,113.07874 h 49.5748 v 82.14173 H 85.2021 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 1,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path37",
    fillRule: "evenodd",
    d: "m 134.77843,113.07874 h 49.5748 v 82.14173 h -49.5748 z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path39",
    fillRule: "evenodd",
    d: "m 134.77843,113.07874 h 49.5748 v 82.14173 h -49.5748 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 1,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path41",
    fillRule: "evenodd",
    d: "m 184.35214,113.07874 h 49.5748 v 82.14173 h -49.5748 z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43",
    fillRule: "evenodd",
    d: "m 184.35214,113.07874 h 49.5748 v 82.14173 h -49.5748 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 1,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path45",
    fillRule: "evenodd",
    d: "m 233.9265,113.07874 h 49.57481 v 82.14173 H 233.9265 Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path47",
    fillRule: "evenodd",
    d: "m 233.9265,113.07874 h 49.57481 v 82.14173 H 233.9265 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 1,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path49",
    fillRule: "evenodd",
    d: "m 100.52476,90.04964 9.46457,-17.322838 9.46457,17.322838 z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path51",
    fillRule: "evenodd",
    d: "m 100.52476,90.04964 9.46457,-17.322838 9.46457,17.322838 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path53",
    fillRule: "evenodd",
    d: "m 150.09956,90.04964 9.46457,-17.322838 9.46457,17.322838 z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path55",
    fillRule: "evenodd",
    d: "m 150.09956,90.04964 9.46457,-17.322838 9.46457,17.322838 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path57",
    fillRule: "evenodd",
    d: "m 199.67436,90.04964 9.46457,-17.322838 9.46457,17.322838 z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path59",
    fillRule: "evenodd",
    d: "m 199.67436,90.04964 9.46457,-17.322838 9.46457,17.322838 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path61",
    fillRule: "evenodd",
    d: "m 249.24916,90.04964 9.46458,-17.322838 9.46457,17.322838 z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path63",
    fillRule: "evenodd",
    d: "m 249.24916,90.04964 9.46458,-17.322838 9.46457,17.322838 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path65",
    fillRule: "evenodd",
    d: "m 268.1783,219.37772 -9.46457,17.32284 -9.46458,-17.32284 z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path67",
    fillRule: "evenodd",
    d: "m 268.1783,219.37772 -9.46457,17.32284 -9.46458,-17.32284 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path69",
    fillRule: "evenodd",
    d: "m 218.6035,219.37772 -9.46457,17.32284 -9.46457,-17.32284 z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path71",
    fillRule: "evenodd",
    d: "m 218.6035,219.37772 -9.46457,17.32284 -9.46457,-17.32284 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path73",
    fillRule: "evenodd",
    d: "m 169.0287,219.37772 -9.46457,17.32284 -9.46457,-17.32284 z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path75",
    fillRule: "evenodd",
    d: "m 169.0287,219.37772 -9.46457,17.32284 -9.46457,-17.32284 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path77",
    fillRule: "evenodd",
    d: "m 119.4539,219.37772 -9.46457,17.32284 -9.46457,-17.32284 z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path79",
    fillRule: "evenodd",
    d: "m 119.4539,219.37772 -9.46457,17.32284 -9.46457,-17.32284 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path81",
    fillRule: "evenodd",
    d: "m 69.87909,219.37772 -9.464569,17.32284 -9.464565,-17.32284 z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path83",
    fillRule: "evenodd",
    d: "m 69.87909,219.37772 -9.464569,17.32284 -9.464565,-17.32284 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: 20,
      fontFamily: "'DejaVu Sans', sans-serif",
      textAnchor: "middle",
      fill: "#000000"
    },
    id: "text89",
    "aria-label": "SUBMIT"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path119",
    d: "m 143.48047,281.89844 v 1.92383 q -1.12305,-0.53711 -2.11914,-0.80079 -0.9961,-0.26367 -1.92383,-0.26367 -1.61133,0 -2.49023,0.625 -0.86915,0.625 -0.86915,1.77735 0,0.96679 0.57618,1.46484 0.58593,0.48828 2.20703,0.79102 l 1.1914,0.24414 q 2.20704,0.41992 3.25196,1.48437 1.05468,1.05469 1.05468,2.83203 0,2.11914 -1.42578,3.21289 -1.41601,1.09375 -4.16015,1.09375 -1.03516,0 -2.20703,-0.23437 -1.16211,-0.23438 -2.41211,-0.69336 v -2.03125 q 1.20117,0.67383 2.35351,1.01562 1.15235,0.3418 2.26563,0.3418 1.68945,0 2.60742,-0.66406 0.91797,-0.66406 0.91797,-1.89453 0,-1.07422 -0.66406,-1.67969 -0.6543,-0.60547 -2.15821,-0.9082 l -1.20117,-0.23438 q -2.20703,-0.43945 -3.19336,-1.37695 -0.98633,-0.9375 -0.98633,-2.60742 0,-1.9336 1.35742,-3.04688 1.36719,-1.11328 3.75977,-1.11328 1.02539,0 2.08984,0.18555 1.06446,0.18554 2.17774,0.55664 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path121",
    d: "m 147.21094,281.41992 h 1.98242 v 8.85742 q 0,2.34375 0.84961,3.37891 0.84961,1.02539 2.7539,1.02539 1.89454,0 2.74415,-1.02539 0.8496,-1.03516 0.8496,-3.37891 v -8.85742 h 1.98243 v 9.10156 q 0,2.85157 -1.41602,4.30664 -1.40625,1.45508 -4.16016,1.45508 -2.76367,0 -4.17968,-1.45508 -1.40625,-1.45507 -1.40625,-4.30664 z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path123",
    d: "m 164.05664,289.03711 v 5.3418 h 3.16406 q 1.5918,0 2.35352,-0.6543 0.77148,-0.66406 0.77148,-2.02149 0,-1.36718 -0.77148,-2.01171 -0.76172,-0.6543 -2.35352,-0.6543 z m 0,-5.99609 v 4.39453 h 2.91992 q 1.44531,0 2.14844,-0.53711 0.71289,-0.54688 0.71289,-1.66016 0,-1.10351 -0.71289,-1.65039 -0.70313,-0.54687 -2.14844,-0.54687 z m -1.97266,-1.6211 h 5.03907 q 2.25586,0 3.47656,0.9375 1.2207,0.9375 1.2207,2.66602 0,1.33789 -0.625,2.1289 -0.625,0.79102 -1.83594,0.98633 1.45508,0.3125 2.25586,1.3086 0.81055,0.98632 0.81055,2.4707 0,1.95312 -1.32812,3.01758 Q 169.76953,296 167.31836,296 h -5.23438 z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path125",
    d: "m 175.79492,281.41992 h 2.93945 l 3.72071,9.92188 3.74023,-9.92188 h 2.93946 V 296 h -1.92383 v -12.80273 l -3.75977,10 h -1.98242 l -3.75977,-10 V 296 h -1.91406 z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path127",
    d: "m 193.06055,281.41992 h 1.97265 V 296 h -1.97265 z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path129",
    d: "m 196.9375,281.41992 h 12.33398 v 1.66016 H 204.0957 V 296 h -1.98242 v -12.91992 h -5.17578 z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: 42,
      fontFamily: "'DejaVu Sans', sans-serif",
      textAnchor: "middle",
      fill: "#000000"
    },
    id: "text93",
    "aria-label": "A"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path132",
    d: "m 60,143.46289 -5.619141,15.23731 h 11.258789 z m -2.337891,-4.08105 h 4.696289 L 74.027344,170 h -4.306641 l -2.789062,-7.85449 H 53.129883 L 50.34082,170 h -4.368164 z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: 42,
      fontFamily: "'DejaVu Sans', sans-serif",
      textAnchor: "middle",
      fill: "#000000"
    },
    id: "text97",
    "aria-label": "A"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path135",
    d: "m 110,143.46289 -5.61914,15.23731 h 11.25879 z m -2.33789,-4.08105 h 4.69629 L 124.02734,170 h -4.30664 l -2.78906,-7.85449 H 103.12988 L 100.34082,170 h -4.368164 z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: 42,
      fontFamily: "'DejaVu Sans', sans-serif",
      textAnchor: "middle",
      fill: "#000000"
    },
    id: "text101",
    "aria-label": "A"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path138",
    d: "m 160,143.46289 -5.61914,15.23731 h 11.25879 z m -2.33789,-4.08105 h 4.69629 L 174.02734,170 h -4.30664 l -2.78906,-7.85449 H 153.12988 L 150.34082,170 h -4.36816 z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: 42,
      fontFamily: "'DejaVu Sans', sans-serif",
      textAnchor: "middle",
      fill: "#000000"
    },
    id: "text105",
    "aria-label": "A"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path141",
    d: "m 210,143.46289 -5.61914,15.23731 h 11.25879 z m -2.33789,-4.08105 h 4.69629 L 224.02734,170 h -4.30664 l -2.78906,-7.85449 H 203.12988 L 200.34082,170 h -4.36816 z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: 42,
      fontFamily: "'DejaVu Sans', sans-serif",
      textAnchor: "middle",
      fill: "#000000"
    },
    id: "text109",
    "aria-label": "A"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path144",
    d: "m 260,143.46289 -5.61914,15.23731 h 11.25879 z m -2.33789,-4.08105 h 4.69629 L 274.02734,170 h -4.30664 l -2.78906,-7.85449 H 253.12988 L 250.34082,170 h -4.36816 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordComponent);
export default __webpack_public_path__ + "static/media/PasswordComponent.707110c0bd6c3467d87bb3e06f0fb611.svg";
export { ForwardRef as ReactComponent };